module.exports = new __parcel__URL__("blessedlight.9a453ed9.png").toString();